import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface PreviewWidgetUniDriver extends BaseUniDriver {}
